import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {PageLoader} from "../../components/Loader";
import _ from "lodash";

import {fetchCategoryRoot} from "../../../creators/category.rootChildrens";
import SideBar from "./tpl1/SideBar";
import Content from "./tpl1/Content";
import {Breakpoint} from "../../../libs/breakpoint";
//import {canonical} from "../../../libs/helper";
import Helmet from "react-helmet";
import {canonical} from "../../../libs/helper";


class Facettes extends React.Component {
    constructor(props) {
        super(props);

        this.currentCategoryId = _.get(this.props,"currentCategory");
        this.state = {
            categories : this.props.categories || [],
            lastUpdate : Date.now()
        };

        this.handleCategories = this.handleCategories.bind(this);

        if(this.currentCategoryId){

            this.props.fetchCategoryRoot(this.currentCategoryId);
        }

    }

    /*componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.categoryRootInitialized !== this.props.categoryRootInitialized){
            this.setState({categories: [this.props.categoryRoot._id.toString()]});
        }
    }*/

    categoryByMeta(){
        let categories = _.get(this.props.facette, "categoriesValues") || [];
        categories = [...categories];
        let concordanceGenre = {
            'femme' : "de femmes",
            'homme' : "d'hommes",
            'couple-gay' : "de couples gay",
            'couple-hetero' : "de couples hétéro",
            'couple-lesbien' : "de couples lesbien",
            'trio' : "de trio",
            'groupe' : "de groupe",
            'transsexuel' : "de transsexuel",
            'travesti' : "de travesti"
        }
        let cat = {
            subCat : []
        }
        categories.forEach(item =>{
            if(item.category.slug ==="media"){
                cat["media"] = item.value.title;
            }
            else if(item.category.slug ==="genre"){
                cat["genre"] = concordanceGenre[item.value.slug];
            }
            else{
                cat["subCat"].push(item.value.title);
            }
        });
        return cat;
    }

    metaHelmet() {

        let page = _.get(this.props,'match.params.page') || 1;
        let categoryByMeta = this.categoryByMeta();
        let categories = categoryByMeta.subCat.join(' - ');
        let metaDefault = {
            'h1' : categories
        };
        if(page === 1){
            if(_.get(this.props,"facette.seo.title") && this.props.facette.seo.title !== ""){
                metaDefault = {
                    ...metaDefault,
                    title : this.props.facette.seo.title
                };
            }
            else{
                let media = categoryByMeta.media ? `Les ${categoryByMeta.media}s amateur` : `Les photos et vidéos amateur`;
                let genre = categoryByMeta.genre ? ` ${categoryByMeta.genre}` : ``;
                metaDefault = {
                    ...metaDefault,
                    title : categories ? `${media}${genre} - ${categories} sur Voissa` : `${media}${genre} sur Voissa`
                };
            }
        }
        else{
            metaDefault = {
                ...metaDefault,
                title : categories ? `${categories} | page ${page} sur Voissa` : `page ${page} sur Voissa`
            };
        }

        return metaDefault;
    }

    handleCategories(categories){
        this.setState({categories, lastUpdate : Date.now()});
    }

    render() {
       // console.log(isMobile);
        //console.log(this.state.categories);
        let page = _.get(this.props,'match.params.page') || 1;
        let url = _.get(this.props,'match.url') || "";
        let urlCanonical = canonical(url, "", "facette");

        return !this.props.categoryRootInitialized ? (
                <div id="facettes">
                    <div className="container">
                        <div className="card big">
                            <PageLoader/>
                        </div>
                    </div>
                </div>
            )
            :(
                <div id="facettes">
                    <Helmet>
                        <title>{this.metaHelmet().title }</title>
                        {_.get(this.props, 'facette.indexable') === false ? (<meta name="robots" content="noindex" />) : null}
                        <link rel="canonical" href={urlCanonical} />
                    </Helmet>
                    <div className="container">
                        <div className="facettes-container">
                            <Breakpoint sizeAbove="sm" >
                                <SideBar
                                    categoryId={this.props.categoryRoot._id}
                                    handleCategories={this.handleCategories}
                                    lastUpdate={this.state.lastUpdate}
                                    categories={this.state.categories}
                                    facetteId={_.get(this.props,"facette._id")}
                                    facetteAncre={_.get(this.props, 'facetteAncre')}
                                />
                            </Breakpoint>

                            <div className={"card results-panel"}>
                                <Content
                                    categoryId={this.props.categoryRoot._id}
                                    handleCategories={this.handleCategories}
                                    location={this.props.location}
                                    facetteId={_.get(this.props,"facette._id")}
                                    match={this.props.match} category={this.props.categoryRoot}
                                    lastUpdate={this.state.lastUpdate}
                                    categories={this.state.categories}
                                    titleH1={this.metaHelmet().h1}
                                    facetteAncre={_.get(this.props, 'facetteAncre')}
                                />
                                {page === 1
                                    ? <div className={"text-footer"}
                                           dangerouslySetInnerHTML={{__html: _.get(this.props, 'facette.seo.description') || ""}}/>
                                    : null
                                }
                            </div>

                        </div>
                    </div>
                </div>
            )
    }
}


const mapStateToProps = (state) => {
    return {
        categoryRoot : state.categoryRoot.data,
        categoryRootInitialized : state.categoryRoot.initialized,
        categoryRootLoading : state.categoryRoot.loading,

    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCategoryRoot
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Facettes);
